import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=440ae1c1&scoped=true&lang=pug&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"
import style0 from "./Email.scss?vue&type=style&index=0&id=440ae1c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ae1c1",
  null
  
)

export default component.exports